import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createBlock as _createBlock, renderList as _renderList, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { "element-loading-text": "{{ t('payplanDetail.loading', '正在获取数据，请稍后') }}" }
const _hoisted_2 = {
  key: 0,
  style: {"margin-top":"15px","margin-left":"15px","font-size":"16px","color":"red"}
}
const _hoisted_3 = {
  key: 1,
  style: {"margin-top":"15px","margin-left":"15px","font-size":"16px","color":"red"}
}
const _hoisted_4 = { class: "vo-ft-dag" }
const _hoisted_5 = { style: {"margin-left":"8px"} }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" payment ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("确定")

import { onMounted, reactive, ref, unref, watch, nextTick } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { ElMessage } from 'element-plus';

import { GetContractApi, GetDraftEditDataApi, RelContractListApi } from '@/apis/contract/contract.api';
import { GetAuditUserListApi } from '@/apis/contract/contract.draft.api';
import { InvolvedUserList } from '@/apis/tasks/task.api';

import { useCtCategory } from '@/store/category.store';
import { useDictionary } from '@/store/dictionary.store';
import { useMainstay } from '@/store/mainstay.store';
import { useTrades } from '@/store/treade.store';
import { useCurrency } from '@/store/currency.store';
import { useAppStore } from '@/store/app';
import { RmbcCpital, formatTools } from '@/utils';

// 添加多语言支持
import { useLocales } from '@/hooks/useLocales';
import PayPlanList from './components/payplanlist.vue';
import MaterialList from './components/materiallist.vue';
import SupplementMaterial from './components/supplementmaterial.vue';
import AuditLocusDrawer from '@/views/contracts/list/components/auditlocus.vue'; // 这里使用了List中的“轨迹”组件，Rmark by 摸鱼王 2024年3月26日


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { t } = useLocales();

const dicStores = useDictionary();
const login = useAppStore().getLoginInfo;
const { query } = useRoute();
const { go, push } = useRouter();
const router= useRouter();
const route = useRoute();
const { fDate, fAmount } = formatTools();

const payPlanViewRef = ref<InstanceType<typeof PayPlanList>>();
const materiallistRef = ref<InstanceType<typeof MaterialList>>();
const supplementMaterialRef = ref<InstanceType<typeof SupplementMaterial>>();
const auditLocusDrawerRef = ref<InstanceType<typeof AuditLocusDrawer>>();

const state = reactive({
	loading: false,
	title: t('contract.detail', '合同详细'),
	detail: {} as any,
	nodeId: '',
	categoryList: [] as any[],
	nodeRuleMaps: {} as any,
	relcontracts: [] as any[],
	endcontract: '',
	continuecontract:'',
	hasend: false,
	hascontinue: false,
	originalcontract: '',
	hasSupplementPerm: false,
	involvedList: [] as any[],
});

const load = {
	/* 获取合同明细 */
	getDraftData: async (contractId: string) => {
		state.loading = true;

		const res = await GetDraftEditDataApi(contractId);
		const { succeeded, errors, data } = res;

		state.loading = false;

		if (!succeeded) {
			ElMessage.error(errors);
		} else {
			state.detail = Object.assign({}, data || {}, { dept_list: [], sure_list: [], audit_list: [], vice_ceo_list: [], ceo_list: [], boss_list: [] });

			/* 获取关联数据(审批人员) */
			load.getAuditUserList(data.id);

			nextTick(() => {
				/* 获取关联数据(付款计划) */
				unref(payPlanViewRef)?.setPlanList(data.id);

				/* 获取关联数据(附件) */
				unref(materiallistRef)?.setFileList(data.id);

				/* 获取参与人并判断补充信息权限，有权限则加载补充附件 */
				load.getInvolvedPerm(data.id).then(() => {
					if (state.hasSupplementPerm) {
						nextTick(() => {
							unref(supplementMaterialRef)?.setFileList(data.id);
						});
					}
				});
			});

			state.title = `${data.name}(${data.no})`;
			state.loading = false;
		}
	},

	/* 获取参与人并判断补充信息权限 */
	getInvolvedPerm: async (contractId: string) => {
		const res = await InvolvedUserList(contractId);
		if (res.succeeded) {
			state.involvedList = res.data || [];
			state.hasSupplementPerm = state.involvedList.some(
				(item: any) => item.node_name === '补充信息' && item.user_id === login.user_account
			);
		}
	},

	getAuditUserList: async (contractId: string) => {
		const { data } = await GetAuditUserListApi(contractId);

		(data || []).forEach((user: any) => {
			const keys = state.nodeRuleMaps.get(user.node_id);
			if (keys) {
				state.detail[keys].push(`${user.user_name}(${user.user_id})`);
			}
		});
	},

	getRelContract: async  (contractId: string) => {
		const res = await RelContractListApi(contractId);
		const { succeeded, errors, data } = res;
		const relcontractslist: any[] = [];
		const continuecontractlist: any[] = [];
		if (!succeeded) {
			ElMessage.error(errors);
		} else {
			data.forEach((a: any) => {
				if (a.contract_source == "ZZHT") {
					relcontractslist.push(a.no);
					state.hasend = true;
				}
				if (a.contract_source == "LXHT") {
					continuecontractlist.push(a.no);
					state.hascontinue = true;
				}
			});
			state.relcontracts = data;
			state.endcontract = relcontractslist.toString();
			state.continuecontract = continuecontractlist.toString();
		}
		if (state.detail.rel_contract_id)
		{
			await load.getOriginalCtApi(state.detail.rel_contract_id)
		}	
	},


	getOriginalCtApi : async (contractId: string) => {
		const res = await GetContractApi(contractId);
		const { succeeded, errors, data } = res;
		if (!succeeded) {
			ElMessage.error(errors);
		} else {
			state.originalcontract = data.no
		}
	},
	



};

const actions = {
	/* 审批流程轨迹 */
	locus: () => {
		if (!state.detail) return;
		
		const { id, created_user_id } = state.detail;
		unref(auditLocusDrawerRef)?.showDrawer(id, created_user_id);
	},

	redirect: (relcontract: any) => {
		router.push({ path: `/contracts/previews`, query: { contractId: `${relcontract}` } });
	},
};


watch(route, (to, from) => {
	// if (router..value)
	router.go(0)
});

onMounted(async () => {
	const contractId = query.contractId as string;
	const currNodeId = (query.nodeId as string) || '';

	const nodeRuleMaps = new Map();
	nodeRuleMaps.set('19902', 'dept_list');
	nodeRuleMaps.set('19903', 'sure_list');
	nodeRuleMaps.set('19904', 'audit_list');
	nodeRuleMaps.set('19909', 'vice_ceo_list');
	nodeRuleMaps.set('19910', 'ceo_list');
	nodeRuleMaps.set('19911', 'boss_list');

	state.nodeRuleMaps = nodeRuleMaps;
	state.nodeId = currNodeId;

	await load.getDraftData(contractId);
	await load.getRelContract(contractId);
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_page_header = _resolveComponent("el-page-header")!
  const _component_el_card = _resolveComponent("el-card")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_card, { shadow: "never" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_page_header, {
          onBack: _cache[1] || (_cache[1] = ($event: any) => (_unref(go)(-1)))
        }, {
          content: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(_unref(state).title), 1)
          ]),
          extra: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_component_el_button, {
                size: "small",
                type: "primary",
                onClick: actions.locus
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('contractList.buttons.trace', '轨 迹')), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
              (_unref(state).hasend)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(t)('contractDetail.message.contractTerminated', '该合同已终止，请查看关联终止合同')) + " " + _toDisplayString(_unref(state).endcontract), 1))
                : _createCommentVNode("", true),
              (_unref(state).detail.contract_limit == 1 && _unref(fDate)(_unref(state).detail.end_day) < _unref(fDate)(new Date()) && _unref(state).hascontinue)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(t)('contractDetail.message.contractExpired', '该合同已过期，请查看关联续约合同')) + " " + _toDisplayString(_unref(state).continuecontract), 1))
                : _createCommentVNode("", true),
              _createVNode(_component_el_descriptions, {
                style: {"margin-top":"15px"},
                border: true,
                column: 3,
                size: "small"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_descriptions_item, {
                    label: _unref(t)('contract.no', '合同编号')
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(state).detail.no), 1)
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_descriptions_item, {
                    label: _unref(t)('contract.name', '合同名称')
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(state).detail.name), 1)
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_descriptions_item, {
                    label: _unref(t)('contractList.table.contractCategory', '合同分类')
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(useCtCategory)().getName(_unref(state).detail.category_id)), 1)
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_descriptions_item, {
                    label: _unref(t)('contractList.table.ourParty', '我方主体'),
                    span: "3"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(useMainstay)().getName(_unref(state).detail.mainstay_id)), 1)
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_descriptions_item, {
                    label: _unref(t)('contractList.table.counterpart', '相对方'),
                    span: "3"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(useTrades)().getName(_unref(state).detail.counterpart_id)), 1)
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  (_unref(state).detail.amount_flag == 'Y')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createVNode(_component_el_descriptions_item, {
                          label: _unref(t)('contractList.table.totalAmount', '合同金额'),
                          span: "2"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(fAmount)(_unref(state).detail.contract_amount)), 1),
                            _createElementVNode("span", _hoisted_5, "(大写：" + _toDisplayString(_unref(RmbcCpital)(_unref(state).detail.contract_amount)) + ")", 1)
                          ]),
                          _: 1
                        }, 8, ["label"]),
                        _createVNode(_component_el_descriptions_item, {
                          label: _unref(t)('contractDetail.form.paymentMethodCurrency', '付款方式/币种'),
                          span: "1"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_tag, { size: "small" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(dicStores).getName('contract_payment', _unref(state).detail.payment)), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_tag, {
                              size: "small",
                              style: {"margin-left":"8px"}
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", null, _toDisplayString(_unref(useCurrency)().getName(_unref(state).detail.currency)), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["label"]),
                        _hoisted_6
                      ], 64))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_descriptions_item, {
                    label: _unref(t)('contractDetail.form.contractLimitType', '期限类别')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_tag, { size: "small" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(dicStores).getName('contract_limit', _unref(state).detail.contract_limit)), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_descriptions_item, {
                    label: _unref(t)('contractList.table.contractTerm', '合同期限')
                  }, {
                    default: _withCtx(() => [
                      (_unref(state).detail.contract_limit == 1)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(_toDisplayString(_unref(fDate)(_unref(state).detail.begin_day)) + " ~ " + _toDisplayString(_unref(fDate)(_unref(state).detail.end_day)), 1)
                          ], 64))
                        : _createCommentVNode("", true),
                      (_unref(state).detail.contract_limit == 2)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(_unref(fDate)(_unref(state).detail.begin_day)) + " ~ " + _toDisplayString(_unref(fDate)(_unref(state).detail.end_day, _unref(t)('contractList.table.noFixedTerm', '无固定期限'))), 1)
                          ], 64))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_descriptions_item, {
                    label: _unref(t)('contractList.table.signingSource', '签订来源')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_tag, { size: "small" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(dicStores).getName('contract_source', _unref(state).detail.contract_source)), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_descriptions_item, {
                    label: _unref(t)('contractDetail.form.signDate', '签订日期')
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(fDate)(_unref(state).detail.sign_day, _unref(t)('draft.createdTime', '无签订日期'))), 1)
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_descriptions_item, {
                    label: _unref(t)('contractDetail.form.contactPhone', '发起人联系电话')
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(state).detail.phone), 1)
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_descriptions_item, {
                    label: _unref(t)('contractDetail.form.contractAmountType', '合同金额类型')
                  }, {
                    default: _withCtx(() => [
                      (_unref(state).detail.amount_flag == 'Y')
                        ? (_openBlock(), _createBlock(_component_el_tag, {
                            key: 0,
                            type: "success",
                            size: "small"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_7
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_unref(state).detail.amount_flag == 'N')
                        ? (_openBlock(), _createBlock(_component_el_tag, {
                            key: 1,
                            type: "warning",
                            size: "small"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)('contractList.table.noAmountContract', '无金额合同')), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_descriptions_item, {
                    label: _unref(t)('contractDetail.form.contractSummary', '合同信息摘要'),
                    span: "3"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(state).detail.remark), 1)
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_descriptions_item, {
                    label: _unref(t)('contractDetail.form.relContract', '关联合同'),
                    span: "3"
                  }, null, 8, ["label"]),
                  (_unref(state).detail.rel_contract_id)
                    ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
                        key: 1,
                        label: _unref(t)('contractDetail.form.originalContract', '原合同'),
                        span: "3"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_button, {
                            type: "primary",
                            link: "",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (actions.redirect(_unref(state).detail.rel_contract_id)))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(state).originalcontract), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["label"]))
                    : _createCommentVNode("", true),
                  ((_unref(state).detail.dept_list || []).length > 0)
                    ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
                        key: 2,
                        label: _unref(t)('contractDetail.table.deptAudit', '部门批核'),
                        span: "3"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).detail.dept_list, (user) => {
                            return (_openBlock(), _createBlock(_component_el_tag, {
                              size: "small",
                              style: {"margin-right":"8px"}
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(user), 1)
                              ]),
                              _: 2
                            }, 1024))
                          }), 256))
                        ]),
                        _: 1
                      }, 8, ["label"]))
                    : _createCommentVNode("", true),
                  ((_unref(state).detail.sure_list || []).length > 0)
                    ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
                        key: 3,
                        label: _unref(t)('contractDetail.table.sureConfirm', '使用人确认'),
                        span: "3"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).detail.sure_list, (user) => {
                            return (_openBlock(), _createBlock(_component_el_tag, {
                              size: "small",
                              style: {"margin-right":"8px"}
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(user), 1)
                              ]),
                              _: 2
                            }, 1024))
                          }), 256))
                        ]),
                        _: 1
                      }, 8, ["label"]))
                    : _createCommentVNode("", true),
                  ((_unref(state).detail.audit_list || []).length > 0)
                    ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
                        key: 4,
                        label: _unref(t)('contractDetail.table.auditMembers', '会签成员'),
                        span: "3"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).detail.audit_list, (user) => {
                            return (_openBlock(), _createBlock(_component_el_tag, {
                              size: "small",
                              style: {"margin-right":"8px"}
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(user), 1)
                              ]),
                              _: 2
                            }, 1024))
                          }), 256))
                        ]),
                        _: 1
                      }, 8, ["label"]))
                    : _createCommentVNode("", true),
                  ((_unref(state).detail.vice_ceo_list || []).length > 0)
                    ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
                        key: 5,
                        label: _unref(t)('contractDetail.table.viceCeoAudit', '分管高级总监/副总裁审批'),
                        span: "3"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).detail.vice_ceo_list, (user) => {
                            return (_openBlock(), _createBlock(_component_el_tag, {
                              size: "small",
                              style: {"margin-right":"8px"}
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(user), 1)
                              ]),
                              _: 2
                            }, 1024))
                          }), 256))
                        ]),
                        _: 1
                      }, 8, ["label"]))
                    : _createCommentVNode("", true),
                  ((_unref(state).detail.ceo_list || []).length > 0)
                    ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
                        key: 6,
                        label: _unref(t)('contractDetail.table.ceoAudit', '执行副总裁审批'),
                        span: "3"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).detail.ceo_list, (user) => {
                            return (_openBlock(), _createBlock(_component_el_tag, {
                              size: "small",
                              style: {"margin-right":"8px"}
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(user), 1)
                              ]),
                              _: 2
                            }, 1024))
                          }), 256))
                        ]),
                        _: 1
                      }, 8, ["label"]))
                    : _createCommentVNode("", true),
                  ((_unref(state).detail.boss_list || []).length > 0)
                    ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
                        key: 7,
                        label: _unref(t)('contractDetail.table.bossAudit', '董事长审批'),
                        span: "3"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).detail.boss_list, (user) => {
                            return (_openBlock(), _createBlock(_component_el_tag, {
                              size: "small",
                              style: {"margin-right":"8px"}
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(user), 1)
                              ]),
                              _: 2
                            }, 1024))
                          }), 256))
                        ]),
                        _: 1
                      }, 8, ["label"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              (_unref(state).detail.amount_flag == 'Y')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createVNode(_component_el_divider, { "content-position": "left" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('contractDetail.title.paymentPlan', '付款计划')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(PayPlanList, {
                      ref_key: "payPlanViewRef",
                      ref: payPlanViewRef
                    }, null, 512)
                  ], 64))
                : _createCommentVNode("", true),
              _createVNode(_component_el_divider, { "content-position": "left" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('contractDetail.title.contractAttachment', '合同附件')), 1)
                ]),
                _: 1
              }),
              _createVNode(MaterialList, {
                ref_key: "materiallistRef",
                ref: materiallistRef
              }, null, 512),
              (_unref(state).hasSupplementPerm)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                    _createVNode(_component_el_divider, { "content-position": "left" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('contracts.supplementAttachment', '补充附件')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(SupplementMaterial, {
                      ref_key: "supplementMaterialRef",
                      ref: supplementMaterialRef,
                      ctId: _unref(state).detail.id
                    }, null, 8, ["ctId"])
                  ], 64))
                : _createCommentVNode("", true)
            ])), [
              [_directive_loading, _unref(state).loading]
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(AuditLocusDrawer, {
      ref_key: "auditLocusDrawerRef",
      ref: auditLocusDrawerRef
    }, null, 512)
  ], 64))
}
}

})